<template>
    <div>
        <b-row>
            <b-col md=12 v-if="cropperiod_data">
                <!-- 封面區域 -->
                <div class="cover-bg" :style="$tools.style.imgCover($config.checkURL('pic',cropperiod_data.project_pic))">
                    <b-row class="proj-cover body-top-full justify-content-md-center" align-v="center">
                        <b-col md="5" class="text-center">
                            <div class="proj-logo-area">
                                <h4>{{ cropperiod_data.project_name }} {{ cropperiod_data.name }}</h4>

                                <!-- 月報標題 -->
                                <h2 v-if="report_type == 'monthly'" class="text-center">
                                    <div class="block-text">{{ getDateMonth }}</div>
                                    {{ $t('menu.analysis_report') }}
                                </h2>
                                <!-- 期作報標題 -->
                                <h2 v-else-if="report_type == 'period'" class="text-center">
                                    {{ $t('menu.crop_records') }}
                                </h2>

                                <h5 class="text-center">{{ getDateRange }}</h5>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div>
                    <i class="fa fa-gift"></i><a :href="getReportURL">{{ getReportURL }}</a>
                    <span class="ml-1">
                        &copy;
                        <a href="https://www.agriweather.online" target="blank">阿龜微氣候 AgriWeather</a>,
                        <a href="http://www.beehivedt.com" target="blank">Beehive Data Technology Co., Ltd.</a> All Rights Reserved.
                    </span>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {
        cropperiod_data: {
            type: Object,
            required: true,
        },
        log_time: {
            type: Array,
            required: true,
        },
        report_type: {
            type: String,
            default: 'monthly', // 月報 monthly, 期作報 period
        },
    },
    data () {
        return {
        }
    },
    mounted ()
    {
        this.emit()
    },
    computed: {
        ...mapState({
            'user_language': state => state.user.language,
        }),

        getReportSaveName ()
        {
            let _file_name = ''

            if ( this.cropperiod_data.project_name )   _file_name += this.cropperiod_data.project_name
            if ( this.cropperiod_data.name )           _file_name += '_' + this.cropperiod_data.name
            if ( this.date_range )                      _file_name += '_' + this.date_range + '_' + this.$t('menu.analysis_report')
            if ( this.date_range_detail )
            {
                let _range = this.date_range_detail.split(' ')
                _file_name += '_' + _range[0] + '_' + _range[2]
            }
            if ( this.user_language )                   _file_name += '_(' + this.user_language + ')'

            return _file_name
        },

        getReportURL ()
        {
            // let _url = this.$route.path + '?id=' + this.$route.query.id
            // if ( this.user_language ) _url += '&lang=' + this.user_language

            let _path = {
                name: this.$route.name,
                query: {
                    id:     this.$route.query.id,   // 一般網址
                    ids:    this.$route.query.ids,  // 去識別化網址
                    lang:   this.user_language,
                },
            }
            let _url = location.origin + this.$router.resolve( _path ).href
            
            return _url
        },

        getDateMonth ()
        {
            let _report_date_range = undefined

            // 報告月份 - 取第一隻感測器的開始日期來判斷月報顯示名稱
            if (this.log_time.length > 0)
            {
                _report_date_range = this.log_time[0]
            }
            else return undefined
            
            if (_report_date_range != undefined)
            {
                let _moment_lang = ( this.user_language ? this.$moment( _report_date_range ).locale( this.user_language ) : undefined )
                
                if (_moment_lang != undefined)
                {
                    return this.$t( 'date.months.' + _moment_lang.format('MMMM') )
                }
            }

            return undefined
        },
        
        getDateRange ()
        {
            // 報告範圍 - 取第一隻感測器的開始 & 結束日期
            if (this.log_time.length > 0)
            {
                let _log_times = this.log_time.slice()

                if      (_log_times.length == 1) return `${ _log_times[0] } - ${ _log_times[0] }`
                else if (_log_times.length > 1)  return `${ _log_times[0] } - ${ _log_times[ _log_times.length - 1 ] }`
                else return undefined
            }
            else return undefined
        },

    },
    methods: {

        emit_ReportURL ()
        {
            this.$emit('report-url', this.getReportURL);
            this.$emit('save-name',  this.getReportSaveName);
        },

        emit_DateRange ()
        {
            this.$emit('date-month', this.getDateMonth);
            this.$emit('date-range', this.getDateRange);
        },

        emit ()
        {
            this.emit_ReportURL()
        },
    }
}
</script>

<style lang="scss" scoped>

.proj-cover
{
    height: 300px;
}

</style>